import { Column, Row } from "@tento-ui/component-builtin";
import { Typography } from "@tento-ui/ui/typography";

export type IndicatorGridItem = {
  $indicator: HTMLElement;
  label: string;
  labelColor?: string;
  withPadding?: boolean;
};

export namespace TaskStorybook {
  /**
   * Creates a grid container for displaying multiple indicator variants
   * with consistent spacing and alignment
   */
  export function createIndicatorGrid(config: {
    items: IndicatorGridItem[];
    itemGap?: string;
  }): HTMLElement {
    const itemGap = config.itemGap ?? "8px";

    const $container = Column.make();
    $container.style.gap = "16px";
    $container.style.alignItems = "flex-start";
    $container.style.flexWrap = "wrap";

    for (const item of config.items) {
      const $item = createIndicatorItem({
        $indicator: item.$indicator,
        label: item.label,
        labelColor: item.labelColor,
        withPadding: item.withPadding,
        gap: itemGap,
      });
      $container.appendChild($item);
    }

    return $container;
  }

  /**
   * Creates a single indicator + label pair with consistent styling
   */
  export function createIndicatorItem(config: {
    $indicator: HTMLElement;
    label: string;
    labelColor?: string;
    withPadding?: boolean;
    gap?: string;
  }): HTMLElement {
    const gap = config.gap ?? "8px";

    const $row = Row.make();
    $row.style.alignItems = "center";
    $row.style.gap = gap;
    $row.style.flexWrap = "wrap";

    config.$indicator.style.background = "var(--bg-hover)";
    config.$indicator.style.borderRadius = "4px";
    config.$indicator.style.flexShrink = "0";
    if (config.withPadding) {
      config.$indicator.style.padding = "2px 4px";
    }

    const $label = Typography.small(config.label);
    if (config.labelColor) {
      $label.style.color = config.labelColor;
    }

    $row.appendChild(config.$indicator);
    $row.appendChild($label);

    return $row;
  }
}
